import { render, staticRenderFns } from "./p15.vue?vue&type=template&id=6ff31e16&scoped=true&"
import script from "./p15.vue?vue&type=script&lang=js&"
export * from "./p15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff31e16",
  null
  
)

export default component.exports